define([
    "underscore",
    "backbone",
    "forms/withdrawal/common_form"
], function(_, Backbone, CommonForm) {
    return CommonForm.extend({
        url: "/rest_withdrawal/validate_otc_form",

        validation: _.extend(CommonForm.prototype.validation, {
            last_name: {
                required: true,
                pattern: 'alphaDashSpacesCommasDots'
            },
            first_name: {
                required: true,
                pattern: 'alphaDashSpacesCommasDots'
            },
            bank_name:{
                required: true,
            },
            bank_account:{
                required: true,
                pattern: 'alphaDashSpacesCommasDots'
            },
            email:{
                required: true,
            },
            mobile_country:{
                required: true,
                pattern: 'digits',
            },
            mobile_rest:{
                required: true,
                pattern: 'digits'
            }

        })

    });
});
